/* eslint-disable react-hooks/exhaustive-deps */
import { CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Footer from "../componenets/Footer";
import Header from "../componenets/Header";
import HeaderMobile from "../componenets/HeaderMobile";
import IncludedProduct from "../componenets/IncludedProduct";
import JoinForm from "../componenets/JoinForm";
// import MoreProducts from "../componenets/MoreProducts";
import keys from "../config/keys";
import strings from "../helper/strings";
import { Product } from "../interfaces/products";
import Cookies from "universal-cookie";
import { Affiliate } from "../interfaces/affiliate";

interface LayoutProps {
  setOpenPayPage: React.Dispatch<React.SetStateAction<boolean>>;
  setUrlIframe: React.Dispatch<React.SetStateAction<string>>;
}

function Layout(props: LayoutProps) {
  const scrollContactUsRef = useRef<any>(null);
  const cookies = new Cookies();
  const executeScroll = () => scrollContactUsRef.current.scrollIntoView();
  let { productId } = useParams();
  const [searchParams] = useSearchParams();
  const [affiliate, setAffiliate] = useState<Affiliate>({});
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [product, setProduct] = useState<Product>();

  useEffect(() => {
    fetch(`${keys}/product-template/getTemplateByProductId/${productId}`)
      .then((response) => response.json())
      .then((res) => {
        if (res.data) {
          const token = searchParams.get("token");
          fetch(`${keys}/product-template/getFullCampaignLink?token=${token}`)
            .then((response) => {
              if (response.ok) {
                return response.json();
              }
              throw new Error("Something went wrong.");
            })
            .then(({ data }) => {
              const params = new Proxy(new URLSearchParams(data) as any, {
                get: (searchParams, prop: any) => searchParams.get(prop),
              });
              cookies.set("traffic_source", params.traffic_source);
              cookies.set("refferer", params.refferer);
              cookies.set("utm_id", params.utm_id);
              cookies.set("utm_source", params.utm_source);
              cookies.set("utm_campaign", params.utm_campaign);
              cookies.set("utm_term", params.utm_term);
              cookies.set("utm_content", params.utm_content);
              cookies.set("source", params.source);
              cookies.set("gooly", params.gooly);
              const temp: any = {
                traffic_source: params.traffic_source,
                utm_id: params.utm_id,
                utm_source: params.utm_source,
                utm_campaign: params.utm_campaign,
                utm_term: params.utm_term,
                utm_content: params.utm_content,
                refferer: Number(params.refferer),
                source: params.source,
                gooly: params.gooly,
                product_id: res.data.productId,
                catalog_id: res.data.catalogId,
                token: process.env.REACT_APP_SITE_KEY,
                isRecaptcha: false,
              };
              Object.keys(temp).forEach((key) => {
                if (temp[key] === null) {
                  delete temp[key];
                }
              });
              setAffiliate(temp);
            })
            .catch((error) => {
              console.log("Request failed", error);
            });
          setProduct(res.data);
        } else {
          setErrorMessage("מוצר ללא קיים");
        }
      });
  }, []);

  return (
    <>
      {product && Object.keys(product).length > 0 ? (
        <Stack>
          <Header
            setOpenPayPage={props.setOpenPayPage}
            setUrlIframe={props.setUrlIframe}
            executeScroll={executeScroll}
            product={product}
          />
          <HeaderMobile
            setOpenPayPage={props.setOpenPayPage}
            setUrlIframe={props.setUrlIframe}
            executeScroll={executeScroll}
            product={product}
          />
          <IncludedProduct benefits={product?.template.benefits} />
          {/* {Object.keys(affiliate).length > 0 && ( */}
          <JoinForm
            affiliate={affiliate}
            scrollContactUsRef={scrollContactUsRef}
          />
          {/* )} */}

          {/* <MoreProducts /> */}
          <Divider light />
          <Typography
            sx={{
              color: "#848484",
              direction: "rtl",
              fontSize: { xs: 14, sm: 14 },
              alignSelf: "center",
              py: 3,
            }}
          >
            {strings.main.rightsReserved}
          </Typography>
          <Footer
            setOpenPayPage={props.setOpenPayPage}
            setUrlIframe={props.setUrlIframe}
            product={product}
            executeScroll={executeScroll}
          />
        </Stack>
      ) : (
        !errorMessage && <CircularProgress sx={{ ml: "37%" }} size={100} />
      )}
      {
        <Typography
          sx={{
            color: "#848484",
            direction: "rtl",
            fontSize: { xs: 18, sm: 30 },
            alignSelf: "center",
            py: 3,
            textAlign: "center",
          }}
        >
          {errorMessage}
        </Typography>
      }
    </>
  );
}

export default Layout;
